import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '@/views/Home.vue'

// 定义路由规则
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    }
]

// 创建路由器实例
const router = createRouter({
    history: createWebHistory(), // 使用 HTML5 History 模式
    routes
})

export default router
